import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';
import HBox from 'components/common/HBox';
import FocusableButton from 'components/common/FocusableButton';
import SimulationRadioButton from './SimulationRadioButton';
import Check from 'components/common/Check';
import { numberWithComma } from 'utils/number';
import React from 'react';

export default function SimulationResultConditions(props) {
  const {
    data,
    additions,
    onAddition,
    onExecute,
    ...rest
  } = props;
  const {
    insulin_amt_list = [],
  } = data;

  const insulin_amts = React.useMemo(() => {
    const hash = {};
    insulin_amt_list.forEach(item => {
      const {
        time_zone_tp_cd,
        insulin_amt,
      } = item;
      hash[time_zone_tp_cd - 1] = insulin_amt;
    });
    const list = [];
    for (let i = 0; i < insulin_amt_list.length; ++i) {
      list.push(hash[i]);
    }
    return list;
  }, [insulin_amt_list]);

  return (
    <HBox full {...ex(['SimulationResultConditions'], rest)}>
      <VBox full>
        <table>
          <tbody>
            <tr>
              <td>
                <VBox vstart>
                  <div>{T('0시~6시')}</div>
                  <div>{T('새벽')}</div>
                </VBox>
              </td>
              <td>
                <div>
                  {T('{0} U', insulin_amts[0])}
                </div>
              </td>
              <td>
                <HBox center vcenter>
                  <FocusableButton {...ex({ triggered: 1 <= additions[0], selected: 1 === additions[0] })} {...{ onClick: onAddition(0, 1) }}>{T('1 U')}</FocusableButton>
                  <FocusableButton {...ex({ triggered: 2 <= additions[0], selected: 2 === additions[0] })} {...{ onClick: onAddition(0, 2) }}>{T('2 U')}</FocusableButton>
                  <FocusableButton {...ex({ triggered: 3 <= additions[0], selected: 3 === additions[0] })} {...{ onClick: onAddition(0, 3) }}>{T('3 U')}</FocusableButton>
                </HBox>
              </td>
              <td>
                <div {...ex({ highlighted: additions[0] })}>
                  {T('{0} U 투여', insulin_amts[0] + (additions[0] || 0))}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <VBox vstart>
                  <div>{T('6시~12시')}</div>
                  <div>{T('오전')}</div>
                </VBox>
              </td>
              <td>
                <div>
                  {T('{0} U', insulin_amts[1])}
                </div>
              </td>
              <td>
                <HBox center vcenter>
                  <FocusableButton {...ex({ triggered: 1 <= additions[1], selected: 1 === additions[1] })} {...{ onClick: onAddition(1, 1) }}>{T('1 U')}</FocusableButton>
                  <FocusableButton {...ex({ triggered: 2 <= additions[1], selected: 2 === additions[1] })} {...{ onClick: onAddition(1, 2) }}>{T('2 U')}</FocusableButton>
                  <FocusableButton {...ex({ triggered: 3 <= additions[1], selected: 3 === additions[1] })} {...{ onClick: onAddition(1, 3) }}>{T('3 U')}</FocusableButton>
                </HBox>
              </td>
              <td>
                <div {...ex({ highlighted: additions[1] })}>
                  {T('{0} U 투여', insulin_amts[1] + (additions[1] || 0))}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <VBox vstart>
                  <div>{T('12시~18시')}</div>
                  <div>{T('오후')}</div>
                </VBox>
              </td>
              <td>
                <div>
                  {T('{0} U', insulin_amts[2])}
                </div>
              </td>
              <td>
                <HBox center vcenter>
                  <FocusableButton {...ex({ triggered: 1 <= additions[2], selected: 1 === additions[2] })} {...{ onClick: onAddition(2, 1) }}>{T('1 U')}</FocusableButton>
                  <FocusableButton {...ex({ triggered: 2 <= additions[2], selected: 2 === additions[2] })} {...{ onClick: onAddition(2, 2) }}>{T('2 U')}</FocusableButton>
                  <FocusableButton {...ex({ triggered: 3 <= additions[2], selected: 3 === additions[2] })} {...{ onClick: onAddition(2, 3) }}>{T('3 U')}</FocusableButton>
                </HBox>
              </td>
              <td>
                <div {...ex({ highlighted: additions[2] })}>
                  {T('{0} U 투여', insulin_amts[2] + (additions[2] || 0))}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <VBox vstart>
                  <div>{T('18시~24시')}</div>
                  <div>{T('저녁')}</div>
                </VBox>
              </td>
              <td>
                <div>
                  {T('{0} U', insulin_amts[3])}
                </div>
              </td>
              <td>
                <HBox center vcenter>
                  <FocusableButton {...ex({ triggered: 1 <= additions[3], selected: 1 === additions[3] })} {...{ onClick: onAddition(3, 1) }}>{T('1 U')}</FocusableButton>
                  <FocusableButton {...ex({ triggered: 2 <= additions[3], selected: 2 === additions[3] })} {...{ onClick: onAddition(3, 2) }}>{T('2 U')}</FocusableButton>
                  <FocusableButton {...ex({ triggered: 3 <= additions[3], selected: 3 === additions[3] })} {...{ onClick: onAddition(3, 3) }}>{T('3 U')}</FocusableButton>
                </HBox>
              </td>
              <td>
                <div {...ex({ highlighted: additions[3] })}>
                  {T('{0} U 투여', insulin_amts[3] + (additions[3] || 0))}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <HBox end>
          <FocusableButton
            {...ex(['ExecuteButton', 'primary'])}
            {...{
              onClick: onExecute,
            }}
          >
            {T('실행하기')}
          </FocusableButton>
        </HBox>
      </VBox>

    </HBox>
  );
}
